export default (dis, store, client) => {
  function dismiss(id) {
    return client.post(`/api/notifications/${id}/mark_read`)
      .then(({ data: { notifications } }) => {
        refresh()
      })
  }

  function dismissAll() {
    return client.post(`/api/notifications/mark_all_read`)
      .then(({ data: { notifications } }) => {
        dis({ type: 'notifications/upsert', payload: { notifications } })
      })
  }

  function refresh() {
    return client.get(`/api/notifications`)
      .then(({ data: { notifications } }) => {
        dis({ type: 'notifications/upsert', payload: { notifications } })
      })
      .catch((error) => {// Check various cancellation indicators
        const isCanceled = 
          error?.code === 'ERR_CANCELED' ||
          error?.code === 'ECONNABORTED' ||
          error?.name === 'CanceledError' ||
          error?.name === 'AbortError' ||
          error?.message?.toLowerCase().includes('abort') ||
          error?.message?.toLowerCase().includes('cancel');
        
        if (isCanceled) {
          return; // Silently handle cancellations
        }
        
        // Throw all other errors
        throw error;
      })
  }

  function show(showId) {
    dis({ type: 'notifications/upsert', payload: { showId } })
  }

  return { dismiss, dismissAll, refresh, show }
}
